(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-announcement-slider"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class AnnouncementSliderSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;
    this.resizeTimeout = null;
    this.showArrows = this.data.show_arrows;
    this.observers = []; 
    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    this.$root.classList.remove('pxu-announcement-slider--initialized');

    const options = {
      prevNextButtons: true,
      pageDots: false,
      groupCells: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: this.data.auto_rotate ? this.data.rotation_speed * 1000 : false,
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();

    setTimeout(() => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
      this.$root.classList.add('pxu-announcement-slider--initialized'); 
    }, 0);
  
    this.initEventListeners();
  }

  waitForElement(selector, callback) {
    const element = this.$root.querySelector(selector);
    
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = this.$root.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
        this.observers = this.observers.filter(o => o !== obs); 
      }
    });

    observer.observe(this.$root, { childList: true, subtree: true });
    this.observers.push(observer); 
  }

  initEventListeners() {
    this.events.register(window, 'resize', () => {
      this.toggleButtonVisibility(false);
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.adjustNavigationButtons();
        this.toggleButtonVisibility(this.showArrows);
      }, 200);
    });

    this.events.register(window, 'load', () => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
    });

    this.events.register(document, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.toggleButtonVisibility(true);
      }
    });

    this.events.register(document, 'click', (event) => {
      if (this.showArrows === false && !event.target.closest('.flickity-prev-next-button')) {
        this.toggleButtonVisibility(false);
      }
    });

    this.toggleButtonVisibility(false);
  }

  toggleButtonVisibility(visible) {
    this.waitForElement('.flickity-prev-next-button', () => {
      const buttons = this.$root.querySelectorAll('.flickity-prev-next-button');
      buttons.forEach(button => {
        button.style.transition = visible ? 'opacity 0.2s ease-out' : 'none';
        button.style.opacity = visible ? '1' : '0';
        button.style.pointerEvents = visible ? 'auto' : 'none';
      });
    });
  }

  adjustNavigationButtons() {
    this.waitForElement('.flickity-prev-next-button', () => {
      const prevButton = this.$root.querySelector('.flickity-prev-next-button.previous');
      const nextButton = this.$root.querySelector('.flickity-prev-next-button.next');
      const announcements = this.$root.querySelectorAll('.pxu-announcement-slider__text');
      const viewport = window.innerWidth;
      const container = this.$root.querySelector('.pxu-section__container');

      if (!announcements.length || !container) return;

      let maxWidth = 0;
      announcements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      const containerRect = container.getBoundingClientRect();
      const minWidth = 650;
      let buttonOffset = 8;

      if (viewport >= 860) {
        const containerLeftEdge = containerRect.left;
        const containerRightEdge = viewport - containerRect.right;
        const announcementMaxWidth = maxWidth;
        const announcementLeftEdge = containerLeftEdge + (containerRect.width - announcementMaxWidth) / 2;
        const announcementRightEdge = containerRightEdge + (containerRect.width - announcementMaxWidth) / 2;

        if (maxWidth <= minWidth) {
          const leftGap = (announcementLeftEdge - containerLeftEdge) / 2;
          const rightGap = (containerRightEdge - announcementRightEdge) / 2;
          const maxOffset = Math.min(leftGap, rightGap);
          buttonOffset = maxOffset;
        }
      }

      prevButton.style.left = `${-buttonOffset}px`;
      nextButton.style.right = `${-buttonOffset}px`;
    });
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
    this.events.unregisterAll();
    this.observers.forEach(observer => observer.disconnect());
    this.observers = [];
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-announcement-slider]').forEach(($section) => {
  Section.init($section, AnnouncementSliderSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.AnnouncementSliderSection = AnnouncementSliderSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-before-after-image"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class BeforeAfterImageSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.onMount();
  }

  onMount() {
    this.compareWrapper = this.$root.querySelector('.pxu-before-after-image__compare-wrapper');
    this.cursor = this.$root.querySelector('.pxu-before-after-image__cursor');
    
    if (this.compareWrapper && this.cursor) {
      this.initEventListeners();
      this.initIntersectionObserver();
    }
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            observer.unobserve(this.compareWrapper);
            this.animateInitialPosition();
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: 0.33
      }
    );

    observer.observe(this.compareWrapper);
  }

  initEventListeners() {
    this.events.register(this.compareWrapper, 'pointerdown', this.handlePointerDown.bind(this));
    this.events.register(this.compareWrapper, 'gotpointercapture', (e) => {
      this.compareWrapper.setPointerCapture(e.pointerId);
    });

    this.events.register(this.cursor, 'keydown', this.handleKeyboardNav.bind(this));

    this.events.register(this.compareWrapper, 'touchstart', (e) => {
      if (e.target === this.cursor || this.cursor.contains(e.target)) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  handlePointerDown(event) {
    if (event.target.tagName === 'A') return;

    event.preventDefault();
    
    const isMobile = window.matchMedia('(max-width: 859px)').matches;
    const isTouch = event.pointerType === 'touch';
    const isOnCursor = event.target === this.cursor || this.cursor.contains(event.target);
    
    if (isMobile && isTouch && !isOnCursor) {
      return;
    }
    
    this.isDragging = true;
    this.compareWrapper.setPointerCapture(event.pointerId);
    
    const handlePointerMove = (e) => {
      if (!this.isDragging || e.buttons === 0) {
        this.events.unregister(this.compareWrapper, 'pointermove', handlePointerMove);
        return;
      }
      
      if (isMobile && isTouch && !isOnCursor) {
        return;
      }
      
      this.updateSliderPosition(e);
    };
    
    this.events.register(this.compareWrapper, 'pointermove', handlePointerMove);
    this.events.register(this.compareWrapper, 'pointerup', () => {
      this.isDragging = false;
      this.events.unregister(this.compareWrapper, 'pointermove', handlePointerMove);
    }, { once: true });
    
    if (!isMobile || !isTouch || isOnCursor) {
      this.updateSliderPosition(event);
    }
  }

  handleKeyboardNav(event) {
    const isVertical = this.compareWrapper.hasAttribute('data-vertical');
    const isValidKey = isVertical 
      ? ['ArrowUp', 'ArrowDown'].includes(event.code)
      : ['ArrowLeft', 'ArrowRight'].includes(event.code);
    
    if (!this.cursor.contains(event.target) || !isValidKey) return;

    event.preventDefault();
    
    const currentPosition = this.getCurrentPosition();
    const step = 1;
    const isDecreasing = isVertical ? event.code === 'ArrowUp' : event.code === 'ArrowLeft';
    
    this.updatePosition(currentPosition + (isDecreasing ? -step : step));
  }

  getCurrentPosition() {
    const position = parseFloat(getComputedStyle(this.compareWrapper).getPropertyValue('--before-after-cursor-position'));
    return isNaN(position) 
      ? parseFloat(getComputedStyle(this.$root).getPropertyValue('--before-after-initial-cursor-position'))
      : position;
  }

  updateSliderPosition(event) {
    const rect = this.compareWrapper.getBoundingClientRect();
    const isVertical = this.compareWrapper.hasAttribute('data-vertical');
    
    const percentage = isVertical
      ? ((event.clientY - rect.top) / rect.height) * 100
      : ((event.clientX - rect.left) / rect.width) * 100;

    this.updatePosition(document.dir === 'rtl' ? 100 - percentage : percentage);
  }

  updatePosition(percentage) {
    const boundedPercentage = Math.min(Math.max(percentage, 0), 100);
    this.compareWrapper.style.setProperty('--before-after-cursor-position', `${boundedPercentage}%`);
  }

  animateInitialPosition() {
    this.compareWrapper.style.setProperty('--before-after-cursor-position', '0%');
    
    setTimeout(() => {
      const startPosition = 0;
      const endPosition = parseFloat(getComputedStyle(this.$root).getPropertyValue('--before-after-initial-cursor-position'));
      const duration = 500;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 2);
        
        this.updatePosition(startPosition + (endPosition - startPosition) * easeProgress);

        if (progress < 1) requestAnimationFrame(animate);
      };

      requestAnimationFrame(animate);
    }, 100);
  }
}

document.querySelectorAll('[data-pxu-before-after-image]').forEach(($section) => {
  Section.init($section, BeforeAfterImageSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.BeforeAfterImageSection = BeforeAfterImageSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-blog-posts"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class BlogPostsSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    const options = {
      draggable: true
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();
  }

  onUnmount() {
    this.carousel.onUnmount();
    this.carousel = null;
  }
}

document.querySelectorAll(`[data-pxu-blog-posts]`).forEach(($section) => {
  Section.init($section, BlogPostsSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.BlogPostsSection = BlogPostsSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-countdown-timer"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
class CountdownTimerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.countdown = this.query('[data-pxu-countdown-timer-countdown]');
    this.days = this.query('[data-pxu-countdown-timer-countdown-days]');
    this.hours = this.query('[data-pxu-countdown-timer-countdown-hours]');
    this.minutes = this.query('[data-pxu-countdown-timer-countdown-minutes]');
    this.seconds = this.query('[data-pxu-countdown-timer-countdown-seconds]');
    this.dateTime = this.query('[data-pxu-countdown-timer-countdown-datetime]');
    this.targetDate = this.dateTime ? Date.parse(this.dateTime.dateTime) : null;
    this.daysInMs = 1000 * 60 * 60 * 24;
    this.hoursInMs = this.daysInMs / 24;
    this.minutesInMs = this.hoursInMs / 60;
    this.secondsInMs = this.minutesInMs / 60;
    this.timeoutId = null;
    this.isLoading = true;

    this.onMount();
  }

  onMount() {
    this.startTimer();
  }

  onUnmount() {
    this.stopTimer();
  }

  updateLoadingState() {
    // Remove the loading class once the countdown is ready.
    this.countdown.classList.remove('pxu-countdown-timer__countdown--loading');
  }

  startTimer() {
    const interval = 1000;
    let expectedTime = Date.now() + interval;

    // If the target date has already passed, handle countdown completion.
    if (this.targetDate <= Date.now()) {
      this.updateLoadingState();
      this.handleCountDownComplete();
      return;
    }

    const countDown = () => {
      const currentDate = Date.now();
      const timeDiff = this.targetDate - currentDate;

      // If time difference is zero or less, stop the timer and handle countdown completion.
      if (timeDiff <= 0) {
        this.stopTimer();
        this.handleCountDownComplete();
        return;
      }

      // Convert the time difference, calculate the drift, and adjust the expected time.
      const remainingTime = this.convertTime(timeDiff);
      const drift = currentDate - expectedTime;
      expectedTime += interval;

      // Update the loading state and update the DOM with the remaining time.
      if (this.isLoading) this.updateLoadingState();
      this.updateDom(remainingTime);

      this.timeoutId = setTimeout(countDown, Math.max(0, interval - drift));
    };

    this.timeoutId = setTimeout(countDown, interval);
  }

  stopTimer() {
    // Stop the countdown and clear the timeout.
    clearTimeout(this.timeoutId);
  }

  convertTime(timeInMs) {
    // Convert the time difference into days, hours, minutes, and seconds.
    const days = parseInt(timeInMs / this.daysInMs, 10);
    timeInMs -= days * this.daysInMs;

    const hours = parseInt(timeInMs / this.hoursInMs, 10);
    timeInMs -= hours * this.hoursInMs;

    const minutes = parseInt(timeInMs / this.minutesInMs, 10);
    timeInMs -= minutes * this.minutesInMs;

    const seconds = parseInt(timeInMs / this.secondsInMs, 10);

    // Return an object with the calculated time.
    return { days, hours, minutes, seconds };
  }

  updateDom(dateObj) {
    // Update DOM elements with the remaining time.
    const { days, hours, minutes, seconds } = dateObj;
    this.days.textContent = days;
    this.hours.textContent = hours;
    this.minutes.textContent = minutes;
    this.seconds.textContent = seconds;
  }

  handleCountDownComplete() {
    // Update the DOM once the countdown is complete.
    this.updateDom({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    // Add the complete class once the countdown is complete.
    this.countdown.classList.add('pxu-countdown-timer__countdown--complete');
  }
}

document.querySelectorAll(`[data-pxu-countdown-timer]`).forEach(($section) => {
  Section.init($section, CountdownTimerSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.CountdownTimerSection = CountdownTimerSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-highlights-banner"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class HighlightsBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-highlights-banner]`).forEach(($section) => {
  Section.init($section, HighlightsBannerSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.HighlightsBannerSection = HighlightsBannerSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-banner"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoBannerSection extends Section {
 constructor($root) {
   super($root);
   this.$root = $root;
   this.$video = this.query('.pxu-video-banner__video');
   this.id = $root.id;
   this.data = this.loadData();
   this.observer = null;

   this.onMount();
 }

 onMount() {
   this.initIntersectionObserver();
 }

 onUnmount() {
   if (this.observer) {
     this.observer.unobserve(this.$root);
   }
 }

 initIntersectionObserver() {
   this.observer = new IntersectionObserver((entries, observer) => {
     entries.forEach(entry => {
       if (entry.isIntersecting) {
         if (this.$video) {
           this.initShopifyVideo();
         }
         observer.unobserve(this.$root);
       }
     });
   }, { threshold: 0 });
   this.observer.observe(this.$root);
 }

 initShopifyVideo() {
   if (!this.$video) return;
   const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

   if(prefersReducedMotion){
    this.$video.removeAttribute('autoplay');
    this.$video.setAttribute('controls', '');
   } else {
    this.$video.play();
   }
 }
}

document.querySelectorAll('[data-pxu-video-banner]').forEach(($section) => {
 Section.init($section, VideoBannerSection);
});

if (Shopify.designMode) {
 window.PxuThemeSections.VideoBannerSection = VideoBannerSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-with-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoWithTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.$shopifyVideo = this.query('.pxu-video-with-text__video');
    this.id = $root.id;
    this.data = this.loadData();
    this.observer = null;

    this.onMount();
  }

  onMount() {
    if (this.$shopifyVideo) this.initIntersectionObserver();
  }

  onUnmount() {
    if (this.$shopifyVideo) this.observer.unobserve(this.$root);
  }


  initIntersectionObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.initVideo();
          observer.unobserve(this.$root);
        }
      });
    }, { threshold: 0 });
    this.observer.observe(this.$root);
  }

  initVideo() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      this.$shopifyVideo.setAttribute('controls', '');
    } else if (this.data.enableVideoAutoplay) {
      this.$shopifyVideo.play();
    }
  }
}

document.querySelectorAll('[data-pxu-video-with-text]').forEach(($section) => {
  Section.init($section, VideoWithTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.VideoWithTextSection = VideoWithTextSection;
}

  } catch(e) { console.error(e); }
})();
})();
